export function mobilecheck() {
  return (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  );
}

export const isAdmin = userData =>
  userData &&
  (userData.id === 'iOTlhMsIEUS4uCZ1qAWAPJ1VEzm2' ||
    userData.id === '4exSLu2TV8YY71fiTFWC6RHb0z32');
